module.exports = __webpack_public_path__ + "static/img/main.baea7eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/Nihilumbra/top/main.jpg
// module id = tXrT
// module chunks = 0